import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_XOR_PARAMETERS,
    templateUrl: "./xor-parameters.component.html",
    standalone: false
})
export class EWizXorParametersComponent extends EWizDynamicBaseClassComponent {}
